import type { PropsWithChildren } from "react";
import { createContext } from "react";
import { useHandleModalState } from "../hooks";
import { Modal } from "../modal";
import type { ModalContextProps } from "../types";

export const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export const ModalProvider = ({ children }: PropsWithChildren) => {
    const value = useHandleModalState();
    const { modalContent, closeModal, isOpen, iconName } = value;

    return (
        <ModalContext.Provider value={value}>
            {children}
            <Modal onClose={closeModal} isOpen={isOpen} iconName={iconName}>
                {modalContent}
            </Modal>
        </ModalContext.Provider>
    );
};
